import copyText from './common/copyText';
import debounce from './common/debounce';
import dbClick from './common/dbClick';
import crmebAuthDirective from './crmebAuth';

export default function directive(app: any) {
    app.directive('copyText', copyText);
    app.directive('debounce', debounce);
    app.directive('dbClick', dbClick);
    app.directive('crmebAuth', crmebAuthDirective);
}
